<template>
  <div id="list" ref="list" @scroll="scrolled.bind(list)($event)" :class="{fill: fill}">

    <div v-if="flip" class="end-state">
      <v-progress-circular v-if="!list.loaded || (list.loaded && !list.noMoreItems && lazy)" style="margin: 0 auto;" indeterminate color="primary" :size="40"></v-progress-circular>
      <v-btn v-else-if="list.loaded && !list.noMoreItems && !lazy" style="margin: 0 auto;" color="primary" @click="loadMore" :loading="list.lockout">Load More</v-btn>
      <template v-else>
        <vo-list-footer v-if="endState" :list="list"></vo-list-footer>
      </template>
    </div>
    

    <div class="list-container">
      <div v-if="list.items" class="list-item" :class="{cursor: selectable}" v-for="(item, i) in list.items" :key="'listItem' + i" @click="itemSelected(item)">

        <template v-if="item">
          <template v-if="itemComponent">
            <component :v-ripple="selectable" class="list-component" :is="itemComponent" :item="item" :selected="selected"></component>
          </template>
          
          <slot :item="item" :i="i" name="itemSlot"></slot>
        </template>

      </div>
    </div>

    <div v-if="!flip" class="end-state">
      <v-progress-circular v-if="!list.loaded || (list.loaded && !list.noMoreItems && lazy)" style="margin: 0 auto;" indeterminate color="primary" :size="40"></v-progress-circular>
      <v-btn v-else-if="list.loaded && !list.noMoreItems && !lazy" style="margin: 0 auto;" color="primary" @click="loadMore" :loading="list.lockout">Load More</v-btn>
      <template v-else>
        <vo-list-footer v-if="endState" :list="list"></vo-list-footer>
      </template>
    </div>
    
  </div>
</template>

<script>

  export default {

    data () {
      return {
        limit: 25
      }
    },
    
    props: {
      
      list: {
        required: true
      },
      
      itemComponent: {
        required: false
      },
      
      selected: {
        required: false
      },
      
      selectable: {
        type: Boolean,
        required: false
      },
      
      lazy: {
        type: Boolean,
        default: false,
        required: false
      },

      endState: {
        type: Boolean,
        default: true
      },

      flip: {
        type: Boolean,
        default: false
      },

      fill: {
        type: Boolean,
        default: false
      },

      forceBottom: {
        type: Boolean,
        default: false
      }

    },
    
    methods: {
      
      itemSelected (item) {
        this.$emit('itemSelected', item);
      },

      scrolled (e) {
        if (!this.lazy) return;
        this.list.scrolled.bind(this.list)({ scroller: e.target, vm: this });
      },

      // Scroll to bottom, only if already at the bottom
      stickToBottom () {
        if (this.$refs.list.scrollTop === this.$refs.list.scrollHeight - this.$refs.list.clientHeight) {
          this.$nextTick(() => {
            if (this.$refs.list.scrollTop !== this.$refs.list.scrollHeight - this.$refs.list.clientHeight) {
              this.$refs.list.scrollTop = this.$refs.list.scrollHeight;
            }
          });
        }
      },

      loadList () {

        this.loading = true;
        this.list.loadList()
        .then(data => {
          
          if (this.flip) {
            this.$nextTick(e => {
              this.toBottom();
            });
          }

        })
        .catch(e => {
          console.log('\n..! List.vue (' + (this.list.name || 'Unnamed List') + ') - loadList Error:', e);
        });
      },

      loadMore () {
        this.loading = true;
        this.list.loadMore();
      },

      toBottom () {
        this.$refs.list.scrollTop = this.$refs.list.scrollHeight;
      }

    },

    watch: {
    
      'list.params': {
        handler (e) {
          console.log('\nO-O List.vue Watch (' + (this.list.name || 'Unnamed List') + '): list.params changed');
          this.loadList();
        },
        deep: true
      },

      'list.filters': {
        handler (e) {
          console.log('\nO-O List.vue Watch  (' + (this.list.name || 'Unnamed List') + '): list.filters changed');
          this.loadList();
        },
        deep: true
      }

    },

    created () {
      if (this.list && !this.list.loaded) {
        this.loadList();
      }

      if (!this.forceBottom && this.list.scrollTop) {
        this.$nextTick(() => {
          this.$refs.list.scrollTop = this.list.scrollTop;
        });
      }
      else if (this.forceBottom) {
        this.$nextTick(() => {
          this.$refs.list.scrollTop = this.$refs.list.scrollHeight;
        });
      }
    }
  }

</script>

<style lang="scss" scoped>

  @import '../css/global.scss';

  #list {

    position: relative;

    &.fill {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      @include scrollable();
    }

    .list-container {

      .list-item {
        position: relative;
        user-select: none;

        &.cursor {
          cursor: pointer;
        }
      }

    }

    .end-state {
      text-align: center;
      padding: 8px 0;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/List.vue